import React from "react";
import Modal from "../modal";
import StudentSchoolHistoryModalProps from "./SchoolHistoryModal";
import moment from "moment";

const StudentSchoolHistoryModal = React.memo(({ studentSchoolHistory = [], show = false, setShow }: StudentSchoolHistoryModalProps) => {
  return <Modal
    open={show}
    extraWide
    onCancel={() => setShow(current => !current)}
  >
    <>
      {studentSchoolHistory.length === 0 && <h3 className="text-2xl font-semibold">No history for this student</h3>}
      {studentSchoolHistory.length > 0 && <>
        <h3 className="text-2xl font-semibold text-ptsblue-500" style={{ color: '#005782' }}>Student School History</h3>
        <table className="block overflow-y-scroll max-h-30rem" style={{ maxHeight: '30rem' }}>
          <thead>
            <th>Student</th>
            <th>District</th>
            <th>School</th>
            <th>Start Date</th>
            <th className="inline-block" style={{ marginLeft: '2rem' }}>End Date</th>
          </thead>
          <tbody className="text-sm align-middle">
            {studentSchoolHistory.map((item, index) =>
              <tr className={`${index === 1 ? `bg-gray-100` : (index % 2 === 0 ? `bg-light-100` : `bg-gray-100`)}`} key={`${item.studentName.replace(/ /g, '-')}-${item.districtName.replace(/ /g, '-')}-${item.schoolName.replace(/ /g, '-')}-${moment(item.startDate).format('MM/DD/YYYY HH:mm:ss')}-${moment(item.endDate).isValid() ? moment(item.startDate).format('MM/DD/YYYY') : ''}`}>
                <td className="p-2">{item.studentName}</td>
                <td className="p-2">{item.districtName}</td>
                <td className="p-2">{item.schoolName}</td>
                <td className="p-2">{moment(item.startDate).format('MM/DD/YYYY')}</td>
                <td className="p-2" style={{ marginLeft: '2rem' }}>{moment(item.endDate).isValid() ? moment(item.endDate).format('MM/DD/YYYY') : ''}</td>
              </tr>
            )}
            <th></th>
          </tbody>
        </table>
      </>}
    </>
  </Modal>;
});
export default StudentSchoolHistoryModal;